import React, { useEffect, useState } from "react";
import RequestTable from "../../../Component/requestTable";
import Loader from "../../../Component/loader";
import { customErrorHandler, toTitleCase } from "../../../Utils/helper";
import { useAuth } from "../../../Utils/Auth";
import bankService from "../../../Services/apiService/bank-service";
import RenewPermission from "../../../Component/edit_permission";
import { toast } from "react-toastify";
import Confirmation_dialog from "../../../Component/confirmation_dialog";
import Confirm_dialog from "../../../Component/confirmation_dialog/confirm_dialog";

const BankRequests = () => {
  const auth = useAuth()
  const [requests, setRequests] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [submitData, setSubmitData] = useState({});
  const [showPermissionDialog, setShowPermissionDialog] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState([])
  const confirmDialogInitialState = {
    show: false,
    title: "",
    message: "",
    confirmText: "",
    cancelText: "",
    isConfirm: false,
    isDenied: false,
    data: "",
    onSuccess: () => { }
  };
  const [showConfirmDialog, setShowConfirmDialog] = useState(
    confirmDialogInitialState
  );
  const [paginationData, setPaginationData] = useState({
    page: 1,
    totalPages: 1,
    totalItems: 0,
    limit: 10,
  });

  const [isLoading, setIsLoading] = useState(false);

  const startIndex = Math.min(
    (paginationData.page - 1) * paginationData.limit + 1
  );
  const endIndex = Math.min(
    paginationData.page * paginationData.limit,
    paginationData.totalItems
  );

  const fetchData = async (page) => {
    try {
      setIsLoading(true)
      const res = await bankService.getBankAllRequest(auth.user, page || paginationData.page, paginationData.limit, "", selectedType);
      if (res) {
        const data = res?.data?.data?.map((item) => ({
          ...item,
          createdAt: new Date(item.createdAt)
            .toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            })
            .replace(/am|pm/i, (match) => match.toUpperCase()),
          //For Future Use
          //   updatedAt: new Date(item.updatedAt).toLocaleString("en-IN", {
          //     timeZone: "Asia/Kolkata",
          //     day: "2-digit",
          //     month: "2-digit",
          //     year: "numeric",
          //     hour: "2-digit",
          //     minute: "2-digit",
          //     second: "2-digit",
          //     hour12: true,
          //   }),
        }));
        setRequests(data)
        setPaginationData((state) => ({
          ...state,
          page: res?.data?.pagination?.page,
          totalPages: res.data?.pagination?.totalPages,
          totalItems: res.data?.pagination?.totalItems,
          limit: res.data?.pagination?.limit,
        }));
      }
    }
    catch (err) {
      toTitleCase(customErrorHandler(err.message, "Something went wrong"));
    }
    setIsLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [selectedType])

  const handleApprove = async (data) => {
    setSubmitData(data)
    if (data?.type === "New") {
      setShowPermissionDialog(true)
    }
    else{
      const payload = {
      bankId: data.bankId,
      isApproved: true,
      type: data?.type,
      subAdmins : []
      }
      await editDeleteApprove(payload)
      await fetchData()
    }
  };

  const handleReject = async (data) => {
    const payload = {
      bankId: data.bankId,
      isApproved: false,
      type: data.type,
      subAdmins: []
    };
    try {
      const res = await bankService.bankRequestApproveReject(auth.user, payload);
      if (res) {
        toast.success(toTitleCase(res?.data?.message));
        await fetchData();
      }
    } catch (error) {
      toTitleCase(customErrorHandler(error))
    }
  };

  const pageHandler = (selectedPage) => {
    fetchData(selectedPage);
  };

  const newBankApprove = async (data) => {
    const payload = {
      bankId: submitData.bankId,
      isApproved: true,
      type: "New",
      subAdmins : data.subAdmins || []
    }
    const res = await bankService.bankRequestApproveReject(auth.user, payload);
    if (res) {
      toast.success(toTitleCase(res?.data?.message))
      setShowPermissionDialog(false)
      fetchData()
    }
  }

const editDeleteApprove = async (payload) => {
  try {
    const res = await bankService.bankRequestApproveReject(auth.user, payload);
    if (res?.data) {
      toast.success(toTitleCase(res.data.message));
    }
    await fetchData();
  } catch (error) {
    toTitleCase(customErrorHandler(error))
  }
};


  const getSelectedPermissionWithSubmit = async (data) => {
    if (data.subAdmins.length === 0) {
      setShowPermissionDialog(false)
      handleConfirmDialogOpen(
        "You Have Not Given any Permission to subadmins still want to proceed ?",
        "Yes",
        "Cancel",
        newBankApprove
      );
    }
    else{
      await newBankApprove(data)
    }
  }

  const handleConfirmDialogClose = () => {
    setShowConfirmDialog(confirmDialogInitialState);
  };

  const handleConfirmDialogOpen = (message, confirmText, cancelText , onSuccess) => {
    setShowConfirmDialog((state) => ({
      ...state,
      show: true,
      message: toTitleCase(message),
      confirmText: confirmText,
      cancelText: cancelText,
      onSuccess : onSuccess
    }));
  };

  return (
    <div className="container">
      <RequestTable
        data={requests}
        columns={[
          { field: 'createdAt', headerName: 'Date & Time' },
          { field: 'subAdminName', headerName: 'Requester', },
          {
            field: 'type',
            headerName: 'Request Type',

          },
          { field: 'bankName', headerName: 'Bank Name' },
          { field: 'accountHolderName', headerName: 'Acc Holder', },
          { field: 'accountNumber', headerName: 'Acc Number', },
          { field: 'ifscCode', headerName: 'Ifsc' },
          { field: 'upiId', headerName: 'Upi Id' },
          { field: 'upiNumber', headerName: 'Upi Number' },
          { field: 'upiAppName', headerName: 'Upi App', },



        ]}
        requestTypes={[{ option: 'New Bank Requests', value: 'New' }, { option: 'Edit Bank Requests', value: 'Edit' }, { option: 'Delete Bank Requests', value: 'Delete' }]} // obj make type+value
        onApprove={handleApprove}
        onReject={handleReject}
        title="Bank Requests"
        filter={{ isFilterDropDownShow: true }}
        page={paginationData.page}
        totalPage={paginationData.totalPages}
        startIndex={startIndex}
        endIndex={endIndex}
        totalData={paginationData.totalItems}
        onPageChange={pageHandler}
        setSelectedType={setSelectedType}
        selectedType={selectedType}
      />
      <Loader
        isLoading={isLoading}
        spinnerType="bar"
        color="#ff5722"
        message="Processing..."
      />

      <RenewPermission
        show={showPermissionDialog}
        handleClose={() => setShowPermissionDialog(false)}
        onSubmit={getSelectedPermissionWithSubmit}
        isBackButtonShow={false}
      />

      <Confirmation_dialog
        show={showConfirmDialog.show}
        title={showConfirmDialog.title}
        message={showConfirmDialog.message}
        confirmText={showConfirmDialog.confirmText}
        cancelText={showConfirmDialog.cancelText}
        state={showConfirmDialog}
        onSuccess={showConfirmDialog.onSuccess}
        handleConfirmDialogClose={handleConfirmDialogClose}
      />
    </div>
  );
};


export default React.memo(BankRequests);